<!--
 * @FileDescription: 库存盘点记录详情（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="page-container">
        <div class="page-container-height">
            <div class="inventory">
                <div class="inventory-left">
                    <span>盘点单号：202005130001</span>
                    <span>盘点人：张三</span>
                    <span>盘点日期：2020-05-13</span>
                    <span>盘点仓库：萧山分库</span>
                </div>
                <a-button class="btn-border btn-save-cao inventory-right" @click="onPage">操作日志</a-button>
            </div>
            <template v-if="dataSource.length > 0">
                <a-table :columns="columns"
                         :dataSource="dataSource"
                         :pagination="pagination"
                         @change="handleTableChange"
                         rowKey="key">
                    <template slot="result" slot-scope="text, record">
                        <span class="text-result" v-if="text > 0">+{{text}}</span>
                        <span v-if="text == 0">{{text}}</span>
                        <span class="text-result2" v-if="text < 0">{{text}}</span>
                    </template>
                    <template slot="operation" slot-scope="text, record">
                        <span class="text-result" v-if="text > 0">+￥{{text}}.00</span>
                        <span v-if="text == 0">￥{{text}}.00</span>
                        <span class="text-result2" v-if="text < 0">-￥{{Math.abs(text)}}.00</span>
                    </template>
                    <template slot="footer">
                        <div class="tab-footer-text">合计：
                            <span class="tab-footer-text1">盘亏</span>
                            <span class="tab-footer-text2">￥</span>
                            <span class="tab-footer-text3">1376.00</span>
                        </div>
                    </template>
                </a-table>
            </template>
            <template v-else>
                <div class="in-tab-table">
                    <div class="in-tab-th">
                        <span v-for="(item,index) in columns" :key="index">{{item.title}}</span>
                    </div>
                    <div class="in-tab-td">
                        <img src="@/assets/image/null-data@2x.png"/>
                        <span>暂无数据</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
    import {getPageAccount} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";
    import moment from 'moment';
    export default {
        mixins:[mixins],
        data(){
            return{
                form: this.$form.createForm(this),
                datetime:'',
                datetime1:'',
                defaultValuetime:'',
                columns: [
                    {
                        title: '商品编号',
                        key: 'name',
                        width:200,
                        dataIndex: 'name',
                    },
                    {
                        title: '商品名称',
                        key: 'data',
                        dataIndex: 'data',

                    },
                    {
                        title: '规格',
                        dataIndex: 'data1',
                        key: 'data1',
                    },
                    {
                        title: '型号',
                        key: 'data2',
                        dataIndex: 'data2',
                    },
                    {
                        title: '系统库存',
                        align: 'right',
                        dataIndex:'data5',
                    },
                    {
                        title: '盘点库存',
                        align: 'right',
                        dataIndex:'data7',
                    },
                    {
                        title: '盘点结果',
                        align: 'right',
                        dataIndex:'data6',
                        scopedSlots: { customRender: 'result' },
                    },
                    {
                        title: '差额',
                        align: 'right',
                        dataIndex:'data8',
                        scopedSlots: { customRender: 'operation' },
                    },
                    {
                        title:'',
                        width:60,
                    }
                ],
                dataSource: [

                ],
            }
        },
        watch: {

        },
        mounted () {

        },
        created () {

        },
        components: {


        },
        methods: {
            moment,
            /**
             * @description: 日期改变（方法描述）
             */
            onChangeData(date, dateString){
                console.log(date,dateString)
                this.datetime = dateString
                this.datetime1 = this.datetime
            },
            /**
             * @description: 搜索（方法描述）
             */
            onSearch(){

            },
            /**
             * @description: 重置（方法描述）
             */
            onRest(){

            },
            onPage(){
                // this.$router.push('')
            },
            /**
             * @description: 分页（方法描述）
             */
            handleTableChange(pagination, filters, sorter){
                console.log(pagination,filters,sorter)
                this.page = pagination.current
                this.size = pagination.pageSize
                this.pagination.current = pagination.current
                this.pagination.pageSize = pagination.pageSize
            },
        },

    }
</script>

<style scoped lang="scss">
    .page-container-height{
        background: #fff;
        padding: 44px 40px;
        .select-record,.input-record{
            width: 240px;
        }
        .text-result{
            color: #1A9A2D;
        }
        .text-result2{
            color: #FF0000;
        }
        .text-result1{
            color: #387BFC;
        }
        .inventory{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .inventory-left{
                color: #565656;
                font-size: 14px;
                span{
                    margin-right: 20px;
                }
            }
        }
        .tab-footer-text{
            display: flex;
            justify-content: flex-end;
            padding-right: 82px;
            align-items: flex-end;
            .tab-footer-text1{
                margin-left: 15px;
                color: #FF0000;
            }
            .tab-footer-text2{
                color: #FF0000;
                font-weight: 700;
            }
            .tab-footer-text3{
                color: #FF0000;
                font-size: 24px;
                font-weight: 700;
                line-height: 24px;
            }
        }
    }
</style>
